import { User as FirebaseUser, onAuthStateChanged } from 'firebase/auth';
import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { auth } from '../firebase/config.tsx';
import EmailVerify from '../pages/EmailVerify.tsx';
import VerifiedPage from '../pages/VerifiedPage.tsx';
import { ROUTES } from './routes.tsx';

// Tracking page changes for analytics
const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('Page changed to:', location.pathname);
  }, [location]);
};

// Adding lazy loading for pages
const HomePage = React.lazy(() => import('../pages/HomePage.tsx'));
const LoginPage = React.lazy(() => import('../pages/LoginPage.tsx'));
const SignUpPage = React.lazy(() => import('../pages/SignUpPage.tsx'));
const ProductsPage = React.lazy(() => import('../pages/ProductPage.tsx'));
const ClientDashboardPage = React.lazy(() => import('../pages/ClientDashboardPage.tsx'));
const IndividualProductPage = React.lazy(() => import('../pages/IndividualProductPage.tsx'));
const CompanyDashboardPage = React.lazy(() => import('../pages/CompanyDashboardPage.tsx'));
const CartPage = React.lazy(() => import('../pages/CartPage.tsx'));
const CheckoutPage = React.lazy(() => import('../pages/CheckoutPage.tsx'));
const GiftGPTPage = React.lazy(() => import('../pages/GiftGPTPage.tsx'));
const GiftGPT2Page = React.lazy(() => import('../pages/GiftGPT2Page.tsx'));

const AppRoutes: React.FC = () => {
  usePageTracking();

  const [user, setUser] = React.useState<FirebaseUser | null>(null);
  onAuthStateChanged(auth, (user) => {
    if (user) {
      setUser(user);
    }
  });

  const verifyUserAndRoute: (elementPage: React.ReactNode, routingLink: string) => React.ReactNode = (elementPage, routingLink) => {
    if (user) {
      if (user.emailVerified) {
        return elementPage;
      } else {
        return <EmailVerify navigationLink={ routingLink } />;
      }
    } else {
      return <LoginPage setUser={ setUser } navigationLink={ routingLink } />;
    }
  };

  return (
    <Routes>
      <Route path={ROUTES.HOME} element={<HomePage />} />
      <Route path={ROUTES.LOGIN} element={<LoginPage setUser={setUser} navigationLink={ROUTES.HOME} />} />
      <Route path={ROUTES.VERIFYEMAIL} element={<EmailVerify navigationLink={ROUTES.HOME} />} />
      <Route path={ROUTES.VERIFIEDPAGE} element={verifyUserAndRoute(<VerifiedPage />, ROUTES.VERIFIEDPAGE)} />
      <Route path={ROUTES.SIGNUP} element={<SignUpPage />} />
      <Route path={ROUTES.PRODUCT} element={<ProductsPage />} /> 
      <Route path={ROUTES.CLIENTDASHBOARD} element={verifyUserAndRoute(<ClientDashboardPage />, ROUTES.CLIENTDASHBOARD)} />
      <Route path={ROUTES.INDIVIDUALPRODUCT} element={<IndividualProductPage />} />
      <Route path={ROUTES.COMPANYDASHBOARD} element={verifyUserAndRoute(<CompanyDashboardPage />, ROUTES.COMPANYDASHBOARD)} />
      <Route path={ROUTES.CHECKOUT} element={verifyUserAndRoute(<CheckoutPage />, ROUTES.CHECKOUT)} />
      <Route path={ROUTES.CART} element={<CartPage />} />
      <Route path={ROUTES.GIFTGPT} element={verifyUserAndRoute(<GiftGPTPage />, ROUTES.GIFTGPT)} />
      <Route path={ROUTES.GIFTGPT2} element={verifyUserAndRoute(<GiftGPT2Page />, ROUTES.GIFTGPT2)} />
      {/* <Route path="*" element={<NotFound />} /> */}
    </Routes>
  );
};

export default AppRoutes;
